import { render, staticRenderFns } from "./fatRemoval.vue?vue&type=template&id=9dec2af2&scoped=true&"
import script from "./fatRemoval.vue?vue&type=script&lang=js&"
export * from "./fatRemoval.vue?vue&type=script&lang=js&"
import style0 from "./fatRemoval.vue?vue&type=style&index=0&id=9dec2af2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dec2af2",
  null
  
)

export default component.exports